import { render, staticRenderFns } from "./CoachSettingCoachingAccolades.vue?vue&type=template&id=50690566&"
import script from "./CoachSettingCoachingAccolades.vue?vue&type=script&lang=ts&"
export * from "./CoachSettingCoachingAccolades.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports